// extracted by mini-css-extract-plugin
export default {"approachCard":"ApproachCard_approachCard__CAbjb"};